import React from 'react';
import Logo from '../Logo/PDTRLOGO.png';
import QRCODE from '../../QRCODE/PDTRQR.png';


const BillPrint = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px',
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px',
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
        fontFamily: 'Arial',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
    };

    const cellStyleP = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };
    const cellStyleNew = {
        border: '1px solid #000',
        padding: '0px',
        // marginTop: '15px',
        // height: '20px'
        marginTop: '10px',
        //height: '10px'
    };

    return (
        <div style={containerStyleN}>
            {labelData && (
                <>
                    <div>
                        <div style={{ textAlign: 'center', marginBottom: '0px' }}>
                            <img src={Logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto', width: '100%', height: '75%' }} />
                        </div>

                        <h4 style={{ textAlign: 'center', marginTop: '1px', marginBottom: '0px' }}>TAX INVOICE</h4>
                    </div>

                    <table style={tableStyle}>
                        <tbody>
                            <tr>
                                <td style={{ ...cellStyle, width: '44%', textAlign: 'left' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '15px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Customer Name & Address</h6>
                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.SalePrint.CustomerName}</h6>
                                    {labelData.SalePrint.CustomerAddress ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', fontWeight: 'normal' }}>{labelData.SalePrint.CustomerAddress} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden' }}>Customer Address: Not Available</h6>
                                    )}

                                    {labelData.SalePrint.GSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', fontWeight: 'normal', fontWeight: 'normal' }}>GST NO: {labelData.SalePrint.GSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>GST Number: Not Available</h6>
                                    )}

                                    {labelData.SalePrint.ContactNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', fontWeight: 'normal', fontWeight: 'normal' }}>Contact Number: {labelData.SalePrint.ContactNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Contact Number: Not Available</h6>
                                    )}
                                </td>
                                <td style={{ ...cellStyle, width: '34%', textAlign: 'right' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5px', marginRight: '10px', marginTop: '-15px' }}>Delivery Address</h6>
                                    {labelData.SalePrint.CustomerAddress ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', fontWeight: 'normal' }}>{labelData.SalePrint.CustomerAddress} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Customer Address: Not Available</h6>
                                    )}
                                </td>

                                <td style={{ ...cellStyle, width: '38%', textAlign: 'right' }}>
                                    <div style={{ textAlign: 'left', marginLeft: '5px', marginBottom: '0px', marginTop: '-15px' }}>
                                        <h6 style={{ margin: '5px 10px 0 0', display: 'inline-block' }}>
                                            Invoice No <span style={{ marginLeft: '12px' }}>:</span> {labelData.SalePrint.BillPrefix}{labelData.SalePrint.BillNumber}/{labelData.SalePrint.FinYear}
                                        </h6>
                                    </div>
                                    <div style={{ textAlign: 'left', marginLeft: '5px', marginTop: '5px' }}>
                                        <h6 style={{ margin: '0 10px 0 0', display: 'inline-block' }}>
                                            Invoice Date <span style={{ marginLeft: '3px' }}>:</span> {new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </h6>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>

                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <td style={{ ...cellStyle, width: '10%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>HSN</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '34%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Description</h6>
                                </td>

                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>QTY</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>QTY(p)</h6>
                                </td>

                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Unit Price</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Dis Amt</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>CGST</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>SGST</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>IGST</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>CESS</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '13%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Gross Amount</h6>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {labelData && labelData.SalePrintDetails.map((record, index) => {
                                const isLastRecord = index === labelData.SalePrintDetails.length - 1;
                                const isFirstRecord = index === 0;

                                return (
                                    <tr key={index} style={{ height: '20px' }}>
                                        <td style={{ ...cellStyleP, width: '10%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.HSNCode}
                                                </label>
                                            </div>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '34%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <div style={{ marginLeft: '5px' }}>
                                                <label style={{
                                                    marginTop: '5px',
                                                    fontFamily: 'Arial',
                                                    fontSize: '9px',
                                                    textAlign: 'left',
                                                    wordWrap: 'break-word',
                                                    whiteSpace: 'normal'
                                                }}>
                                                    {record.ItemName}
                                                </label>
                                            </div>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.Quantity !== 0 ? record.Quantity : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.Qtyperpiece !== 0 ? record.Qtyperpiece : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.Rate !== 0 ? record.Rate : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.DiscountAmount !== 0 ? record.DiscountAmount : ''}
                                            </label>
                                        </td>

                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.CGSTAmount !== 0 ? record.CGSTAmount : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.SGSTAmount !== 0 ? record.SGSTAmount : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.IGSTAmount !== 0 ? record.IGSTAmount : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.CESS !== 0 ? record.CESS : ''}
                                            </label>
                                        </td>
                                        <td style={{ ...cellStyleP, width: '13%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                            <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                {record.Amount !== 0 ? record.Amount : ''}
                                            </label>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>


                    </table>

                    <table style={tableStyle}>
                        <tbody>
                            <tr>

                                {/* <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-105px', maxHeight: '20%', width: '72%' }}> */}
                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-105px', maxHeight: '20%', width: '68%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}>BANK   <span style={{ marginLeft: '25px', fontWeight: 'normal' }}>:</span> <span style={{ fontWeight: 'normal' }}>FEDERAL BANK</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}>BRANCH <span style={{ marginLeft: '10px', fontWeight: 'normal' }}>:</span> <span style={{ fontWeight: 'normal' }}>ERNAKULAM BYE PASS</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-13px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}>A/c No <span style={{ marginLeft: '23px', fontWeight: 'normal' }}>:</span> <span style={{ fontWeight: 'normal' }}>16080200007718</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}>IFSC   <span style={{ marginLeft: '33px', fontWeight: 'normal' }}>:</span> <span style={{ fontWeight: 'normal' }}>FDRL0001608</span></h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}>MICR   <span style={{ marginLeft: '30px', fontWeight: 'normal' }}>:</span> <span style={{ fontWeight: 'normal' }}>682049037</span></h6>
                                    <div style={{ textAlign: 'center', marginTop: '-17%', marginLeft: '10px' }}>
                                        <img src={QRCODE} alt="QRCODE" style={{ maxHeight: '15%', margin: '0 auto', width: '35%', marginLeft: '50%', marginTop: '-50px' }} />
                                    </div>
                                </td>

                                {/* <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '17%' }}> */}
                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '20%' }}>
                                    <br></br>
                                    <h6 style={{ marginRight: '10px', marginTop: '-10px', fontFamily: 'arial', fontWeight: 'normal' }}>Taxable Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>CGST Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>SGST Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>IGST Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>CESS Amount</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Round Off</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Grand Total</h6>


                                </td>

                                {/* <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '11%' }}> */}
                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '20%' }}>
                                    <br></br>
                                    <h6 style={{ marginRight: '10px', marginTop: '-5px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.TaxableAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.CGSTAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.SGSTAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.IGSTAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.CESSAmount.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.RoundOff.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.SalePrint.GrandTotal.toFixed(2)}</h6>

                                </td>

                            </tr>

                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody >
                            <tr>

                                <td style={{ ...cellStyleNew, textAlign: 'left', height: '20px', width: '72%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '15px', marginLeft: '10px' }}><AmountInWords amount={labelData.SalePrint.GrandTotal} /></h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style={{...tableStyle,height:'5%'}}>
                        <tbody >
                            <tr>
                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-55px', width: '70.5%' }}>
                                    <br></br>
                                    <h6 style={{ marginRight: '10px', marginTop: '-5px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'none', fontWeight: 'normal' }}>EXECUTIVE NAME : {labelData.SalePrint.SalesMan}</h6>

                                </td>
                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, width: '17%' }}>

                                    <h6 style={{ marginRight: '10px', marginTop: '15px', fontWeight: 'normal' }}>For {labelData.SalePrint.CompanyName}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '35px', fontWeight: 'normal' }}>Authorized Signatory</h6>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody >
                            <tr>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>{labelData.SalePrint.CompanyName}</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '7%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Invoice No</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Invoice Date</h6>
                                </td>
                                <td style={{ ...cellStyle, width: '5%' }}>
                                    <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Invoice Amount</h6>
                                </td>

                            </tr>
                        </tbody>
                        <tbody>

                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'left' }}>
                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                    {labelData.SalePrint.AddressLine !== 0 ? labelData.SalePrint.AddressLine : ''}
                                </label>
                            </td>

                            <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'center' }}>
                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                    {labelData.SalePrint.BillPrefix}{labelData.SalePrint.BillNumber}
                                </label>
                            </td>
                            <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'center' }}>
                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                    {new Date(labelData.SalePrint.BillDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}
                                </label>
                            </td>

                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right' }}>
                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                    {labelData.SalePrint.GrandTotal !== 0 ? labelData.SalePrint.GrandTotal : ''}
                                </label>
                            </td>

                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody >
                            <tr>
                                <td style={{ ...cellStyle, textAlign: 'center', marginTop: '-25px', maxHeight: '10%', width: '72%', fontSize: '10px' }}>
                                    Acknowledgement
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody >
                            <tr>
                                <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-55px', maxHeight: '20%', width: '72%' }}>
                                    <br></br>
                                    <h6 style={{ marginRight: '10px', marginTop: '-5px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'none', fontWeight: 'normal' }}>{labelData.SalePrint.CustomerName}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'none', fontWeight: 'normal' }}>{labelData.SalePrint.CustomerAddress}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'none', fontWeight: 'normal' }}>Total Amount     <span style={{ marginLeft: '30px', fontWeight: 'normal' }}>:</span> {labelData.SalePrint.GrandTotal.toFixed(2)}</h6>
                                    <h6 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'none', fontWeight: 'normal' }}>Total Tax Amount <span style={{ marginLeft: '10px', fontWeight: 'normal' }}>:</span> {labelData.SalePrint.GSTAmount.toFixed(2)}</h6>
                                </td>
                                <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '20%', width: '17%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '25px',fontWeight:'normal' }}>Signature</h6>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                    <table style={tableStyle}>
                        <tbody >
                            <tr>

                                <td style={{ ...cellStyleNew, textAlign: 'left', maxHeight: '5%', width: '72%' }}>
                                    <h6 style={{ marginRight: '10px', marginTop: '15px', marginLeft: '10px' }}><AmountInWords amount={labelData.SalePrint.GrandTotal} /></h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )
            }
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>
        </div >
    );
};

export default BillPrint;
